// Full set of 30 prebuilt voices supported by gemini-3.1-flash-tts-preview.
// Descriptor is a single short adjective chosen for UI hinting — not a
// Google-authoritative label.

export interface VoiceInfo {
  name: string;
  description: string;
}

export const VOICES: VoiceInfo[] = [
  { name: 'Zephyr', description: 'bright' },
  { name: 'Puck', description: 'upbeat' },
  { name: 'Charon', description: 'informative' },
  { name: 'Kore', description: 'firm' },
  { name: 'Fenrir', description: 'excitable' },
  { name: 'Leda', description: 'youthful' },
  { name: 'Orus', description: 'firm' },
  { name: 'Aoede', description: 'breezy' },
  { name: 'Callirrhoe', description: 'easygoing' },
  { name: 'Autonoe', description: 'bright' },
  { name: 'Enceladus', description: 'breathy' },
  { name: 'Iapetus', description: 'clear' },
  { name: 'Umbriel', description: 'easygoing' },
  { name: 'Algieba', description: 'smooth' },
  { name: 'Despina', description: 'smooth' },
  { name: 'Erinome', description: 'clear' },
  { name: 'Algenib', description: 'gravelly' },
  { name: 'Rasalgethi', description: 'informative' },
  { name: 'Laomedeia', description: 'upbeat' },
  { name: 'Achernar', description: 'soft' },
  { name: 'Alnilam', description: 'firm' },
  { name: 'Schedar', description: 'even' },
  { name: 'Gacrux', description: 'mature' },
  { name: 'Pulcherrima', description: 'forward' },
  { name: 'Achird', description: 'friendly' },
  { name: 'Zubenelgenubi', description: 'casual' },
  { name: 'Vindemiatrix', description: 'gentle' },
  { name: 'Sadachbia', description: 'lively' },
  { name: 'Sadaltager', description: 'knowledgeable' },
  { name: 'Sulafat', description: 'warm' },
];

export const VOICE_NAMES = VOICES.map((v) => v.name);

export function isValidVoice(name: string): boolean {
  return VOICE_NAMES.includes(name);
}
